export default {
    //RecordsList
    your_records: 'Ihre Aufnahmen',
    loading_records: 'Laden von Aufnahmen...',
    project_name: 'Name des Kurses',
    class_name: 'Name der Klasse',
    participants: 'Teilnehmer',
    total_size: 'Gesamtgröße',

}